import React, { useState } from "react";
import logo from "../../assets/img/perlingo-favicon.png";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import { useLocation } from "react-router";
import {
  Navbar,
  Nav,
  NavDropdown,
  Form,
  FormControl,
  Button,
} from "react-bootstrap";

const Header = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);
  localStorage.getItem("token") === null ||
    localStorage.getItem("token") === undefined ||
    (localStorage.getItem("token") === "" && window.location("/login"));
  const location = useLocation();

  return (
    <>
      <div className="header-main container-fluid">
        <div className="container menu-bar">
          <Navbar bg="light" className="col-12 p-0 " expand="lg">
            <Navbar.Brand href="/dashboard">
              <div className="logo-header">
                <div className="img-header">
                  <img href="/dashboard" src={logo} alt={logo} />
                </div>
              </div>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mr-auto mr-md-3">
                <Nav.Link
                  className={location.pathname === "/dashboard" && " active"}
                  href="/dashboard"
                >
                  میزکار
                </Nav.Link>
                <Nav.Link
                  className={
                    location.pathname === "/" ||
                    location.pathname === "/question"
                      ? "option active ml-auto"
                      : "option ml-auto"
                  }
                  href="/"
                >
                  مدیریت ایستگاه ها
                </Nav.Link>
                <Nav.Link
                  className={location.pathname === "/wordbank" && "active"}
                  href="/wordbank"
                >
                  بانک لغات
                </Nav.Link>
                <Nav.Link
                  className={
                    location.pathname === "/BadgeManagement" && "active"
                  }
                  href="/BadgeManagement"
                >
                  مدیریت نشان ها
                </Nav.Link>
                <Nav.Link
                  className={
                    location.pathname === "/UserManagement" && "active"
                  }
                  href="/UserManagement"
                >
                  مدیریت کاربران
                </Nav.Link>
                <Nav.Link
                  onClick={() => {
                    localStorage.setItem("token", "");
                  }}
                  href="/login"
                >
                  خروج{" "}
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </div>
    </>
  );
};

export default Header;
